import {CompleterService, LocalData, RemoteData} from "ng2-completer";
import {EventEmitter, Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {GemeindeLocalData} from "../../shared/widgets/gb-gemeinde/GemeindeLocalData";
import {AppGbgemeindeCompleterService} from "./app-gbgemeinde-completer.service";

@Injectable()
export class AppRestCompleterService {

  constructor(private restServiceDataFactory: CompleterService, private gemeindeCompleterService: AppGbgemeindeCompleterService) {
  }

  public remote(observable: any, searchFields: string | null = "", titleField: string | null = ""): RemoteData {
    const remoteData = this.restServiceDataFactory.remote(observable, searchFields, titleField);
    remoteData.dataSourceChange = new EventEmitter();
    return remoteData;
  }

  public local(data: any[] | Observable<any>, searchFields: string | null = "", titleField: string | null = ""): LocalData {
    const localData = this.restServiceDataFactory.local(data, searchFields, titleField);
    localData.dataSourceChange = new EventEmitter();
    return localData;
  }

  public gemeindeLocal (data: any[] | Observable<any>, searchFields: string | null = "", titleField: string | null = ""): GemeindeLocalData {
    const localData: GemeindeLocalData = this.gemeindeCompleterService.gemeindeLocal(data, searchFields, titleField);
    localData.dataSourceChange = new EventEmitter();
    return localData;
  }
}
